module.exports = __webpack_public_path__ + "img/BCM-FPD-detail.c9091d4d.png";